<template>
  <div>
    <article :id="$vnode.key">
      <custom-callout
        ref="callout"
        has-toggle
        controlled
        :opened="isOpen"
        class="mt-2"
        @click:open="toggleCallout(0, !isOpen)"
      >
        <div class="container-fluid">
          <div class="row">
            <div class="col-6 col-md">
              <div class="info-text-title">
                Nombre del Asistente:
              </div>
              <p class="info-text font-weight-bold text-capitalise">
                {{ model.name }}
              </p>
            </div>

            <div class="col-6 col-md">
              <div class="info-text-title">
                Número Puesto/Contrato:
              </div>
              <p class="info-text font-weight-bold">
                {{ model.contractNumber }}
              </p>
            </div>

            <div class="col-6 col-md">
              <div class="info-text-title">
                Tipo de Recurso:
              </div>
              <p class="info-text font-weight-bold">
                {{ parseResourceType }}
              </p>
            </div>
            <div class="col-6 col-md">
              <div class="info-text-title">
                Jornada Diaria:
              </div>
              <p class="info-text font-weight-bold">
                {{ model.dailyShift }} horas
              </p>
            </div>
            <div class="col-6 col-md">
              <div class="info-text-title">
                Cantidad de Estudiantes:
              </div>
              <p class="info-text font-weight-bold">
                {{ model.numberOfStudents }}
              </p>
            </div>
            <div class="col-6 col-md">
              <div class="info-text-title">
                Alternativa de Ubicación:
              </div>
              <p class="info-text font-weight-bold">
                {{ alternativeLocationLabel }}
              </p>
            </div>
            <div
              class="col-12 col-md-auto px-0 mt-2 mt-md-0 d-md-flex justify-content-end"
            >
              <div class="align-self-center pr-4">
                <DropDown :items="menuItems" normal-size />
              </div>
            </div>
          </div>
        </div>
        <template #edition>
          <div class="additional-container p-2">
            <div class="contrainer-tabs">
              <CustomTab
                ref="assistant-service-tabs"
                :no-nav-style="true"
                nav-class="nav-vue-underline"
              >
                <CustomTabItem
                  title="Información Adicional"
                  :active="activeTab == tabIndexes.Informacion_Adicional"
                >
                  <AdditionalInformation
                    :key="keyComponent"
                    v-model="model"
                    :is-disabled="disabledByAcademicYear"
                  />
                </CustomTabItem>

                <CustomTabItem
                  title="Estudiantes Asignados"
                  :active="activeTab == tabIndexes.Estudiantes_Asignados"
                >
                  <Students
                    :key="keyComponent"
                    :assistant-id="model.assistantId"
                    :school-id="model.schoolId"
                    :hr-assistant-id="model.contractNumber"
                    :collections="collections"
                    :academic-year-id="academicYearId"
                    :disabled="disabledByAcademicYear"
                    @refreshCount="refreshCountHandler"
                  />
                </CustomTabItem>

                <CustomTabItem
                  title="Alternativa de Ubicación"
                  :active="activeTab == tabIndexes.Alternativa_Ubicacion"
                  v-if="hasAlternativeLocation"
                >
                  <AlternativeLocation
                    :key="keyComponent"
                    :assistant-id="model.assistantId"
                    :school-id="model.schoolId"
                    :academic-year-id="academicYearId"
                  />
                </CustomTabItem>

                <CustomTabItem
                  title="No está en mi escuela"
                  :active="activeTab == tabIndexes.NoEscuela"
                  v-if="canShowTabIsNotInSchool"
                >
                  <IsNotInMySchool
                    v-model="isNotInMySchoolModel"
                    :reason-options="isNotInMySchoolReasonOptions"
                    :disabled="model.isNotInMySchoolReasonId"
                    :assistant-id="model.assistantId"
                    :school-id="model.schoolId"
                    :academic-year-id="academicYearId"
                    :is-active="activeTab == tabIndexes.NoEscuela && isOpen"
                    @save="handleSaveNoIsMySchool"
                    @cancel="toggleCallout()"
                  />
                </CustomTabItem>
              </CustomTab>
            </div>
          </div>
        </template>
      </custom-callout>
      <div v-if="model.isNotInMySchoolReasonId" class="panel__container">
        <i class="fas fa-bell-exclamation icon" />
        <span class="panel-text">
          El Asistente no se encuentra brindando servicio en la escuela.
        </span>
      </div>
      <div
        v-if="model.manualFlag && !model.isNotInMySchoolReasonId"
        class="panel__container"
      >
        <i class="fas fa-bell-exclamation icon" />
        <span class="panel-text">El Asistente se añadió a la escuela.</span>
      </div>
    </article>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import DropDown from 'dropdown';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import Students from './tabs/Students';
import IsNotInMySchool from './tabs/IsNotInMySchool.vue';
import AdditionalInformation from './tabs/AdditionalInformation.vue';
import AlternativeLocation from './tabs/AlternativeLocation.vue';
import academicYears from '@/utils/constants/academicYears';
import employeeTypes from '@/utils/constants/employeeTypes';

const TAB_INDEXES = Object.freeze({
  Informacion_Adicional: 0,
  Estudiantes_Asignados: 1,
  Alternativa_Ubicacion: 2,
  NoEscuela: 3,
});

export default {
  name: 'ServiceAssistantRow',
  components: {
    CustomCallout,
    ActionButton,
    DropDown,
    CustomTab,
    CustomTabItem,
    Students,
    AdditionalInformation,
    IsNotInMySchool,
    AlternativeLocation,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    collections: {
      type: Object,
      default: () => ({
        resources: {},
        necessities: [],
        serviceAssistants: [],
      }),
    },
    isOpen: {
      type: Boolean,
      default: () => false,
    },
    activeTab: {
      type: Number,
      default: 0,
    },
    academicYearId: { type: [Number, String], default: 0 },
    isNotInMySchoolReasonOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      keyComponent: 0,
      loaded: false,
      assistantInformation: {},
      menuItems: [
        {
          name: 'Información Adicional',
          icon: 'fas fa-info-circle text-green',
          visible: true,
          click: () => this.toggleCallout(0),
        },
        {
          name: 'Estudiantes Asignados',
          icon: 'fas fa-user-plus text-green',
          visible: true,
          click: () => this.toggleCallout(1),
        },
        {
          name: 'Alternativa de Ubicación',
          icon: 'fas fa-map-marker-alt text-green',
          visible: () => this.hasAlternativeLocation,
          click: () => this.toggleCallout(this.tabIndexes.Alternativa_Ubicacion),
        },
        {
          name: 'No está en mi escuela',
          icon: 'fas fa-times-circle text-red',
          border: 'top',
          visible: this.hasPermissions(
            'rrhh.serviceassistant.action.isnotatmyschool'
          ),
          click: () => this.toggleCallout(3),
        },
        {
          visible: this.canShowRevertIsNotInSchool,
          name: 'Revertir No está en mi escuela',
          icon: 'fas fa-times-circle text-red',
          border: 'top',
          click: () => this.handleRevertNoIsMySchool(),
        },
      ],
      isNotInMySchoolModel: {
        reason: null,
        comment: null,
      },
    };
  },
  computed: {
    model() {
      return this.value;
    },
    hasNoSchoolTab() {
      const AVAILABLE_RESOURCE_TYPES = ['REGULAR', 'IRREGULAR'];

      return AVAILABLE_RESOURCE_TYPES.includes(
        this.value.resourceType.toUpperCase()
      );
    },
    tabIndexes() {
      return TAB_INDEXES;
    },
    disabledByAcademicYear() {
      return this.academicYearId >= academicYears.Y2023_2024;
    },
    canShowTabIsNotInSchool() {
      return this.hasPermissions(
        'rrhh.serviceassistant.action.isnotatmyschool'
      );
    },
    isRemProvResource() {
      return this.model.resourceType.id == employeeTypes.RemedioProvisional;
    },
    parseResourceType() {
      if (this.isRemProvResource && this.model.rpServiceType != null) {
        return `${this.model.resourceType.name} - ${this.model.rpServiceType.name}`;
      }

      return this.model.resourceType.name;
    },
    hasAlternativeLocation() {
      return (
        !this.model.manualFlag &&
        this.model.hasAlternativeLocationAssignment
      );
    },
    alternativeLocationLabel() {
      return this.hasAlternativeLocation ? 'Sí' : 'No';
    },
  },
  methods: {
    hasPermissions(permission) {
      return this.$store.getters.HasPermission(permission);
    },
    canShowRevertIsNotInSchool() {
      return (
        this.model.isNotInMySchoolReasonId &&
        this.hasPermissions(
          'rrhh.serviceassistant.action.revertisnotatmyschool'
        )
      );
    },
    async handleSaveNoIsMySchool(payload) {
      this.$emit('save-is-not-in-my-school', {
        assistantSchoolId: this.model.id,
        reasonId: payload.reasonId,
        comment: payload.comment,
      });
    },
    async handleRevertNoIsMySchool() {
      this.$emit('revert-is-not-in-my-school', this.model.id);
    },
    toggleCallout(index, open = true) {
      this.keyComponent++;
      this.$emit('toggle', {
        isOpen: open,
        assistantSchoolId: this.model.id,
        assistantId: this.model.assistantId,
        schoolId: this.model.schoolId,
        activeTab: index,
      });
    },
    async refreshCountHandler(value) {
      this.model.numberOfStudents = value;
    },
  },
  async created() {
    this.keyComponent++;
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (!newValue) return;

        this.isNotInMySchoolModel.reason = this.isNotInMySchoolReasonOptions.find(
          (x) => x.id == newValue.isNotInMySchoolReasonId
        );
        this.isNotInMySchoolModel.comment =
          newValue.isNotInMySchoolReasonComment;
      },
    },
  },
};
</script>

<style scope>
.panel__container .panel-text {
  color: #af6708;
  margin-left: 12px;
}

.panel__container .icon {
  font-size: 22px;
  color: #af6708;
}

.panel__container {
  padding: 16px 25px;
  background: #fff5e8;
  border: 1px solid #fdac41;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

::v-deep .info-text {
  text-transform: capitalize !important;
}
.contrainer-tabs {
  border-radius: 10px;
  background-color: white;
}
</style>
